export default __webpack_public_path__ + "static/media/templateV.4e64050a.png";